export const getStatusBadgeVariant = (status: string) => {
    switch (status) {
        case 'PROCESSING':
            return 'warning';
        case 'CREATED':
            return 'info';
        case 'CANCELLED':
            return 'danger';
        case 'SHIPPED':
            return 'primary';
        case 'PENDING':
            return 'warning';
        case 'PAID':
            return 'success';
        case 'DELIVERED':
            return 'success';
        case 'PENDING_APPROVAL':
            return 'warning';
        case 'PENDING_PROOF':
            return 'info';
        default:
            return 'default';
    }
};